import { z } from "zod";

export const AddSyncAllowedIpSchema = z.object({
  ip: z
    .string()
    .trim()
    .max(45)
    .ip({ message: "請輸入有效的 IPv4 或 IPv6 位址" })
    .refine((ip) => !ip.includes("%"), "IP 不可包含區域識別碼"),
  notes: z.string().trim().max(255, "備註最多 255 字"),
});

export type AddSyncAllowedIpValues = z.infer<typeof AddSyncAllowedIpSchema>;
